<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import StepProgress from "@/components/widgets/StepProgress";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import appConfig from "@/app.config";
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";
import ModalImagePreview from "../master-soal-verifikasi/ModalImagePreview.vue";
import ModalSoalPreview from "../master-soal-verifikasi/ModalSoalPreview.vue";

const REVIEW_STEPS = [
  { key: "PENDING", label: "Pending", desc: "Menunggu", icon: "fa fa-clock", color: "warning" },
  { key: "REVISION", label: "Revision", desc: "Perlu Revisi", icon: "fa fa-redo", color: "danger" },
  { key: "REPAIRED", label: "Repaired", desc: "Sudah Diperbaiki", icon: "fa fa-tools", color: "primary" },
  { key: "COMPLETED", label: "Completed", desc: "Selesai", icon: "fa fa-check", color: "success" },
];

export default {
  page: {
    title: "Review Soal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    StepProgress,
    Datatable,
    Pagination,
    ModalImagePreview,
    ModalSoalPreview,
  },
  computed: {
    tipeNormalized() {
      return this.previewDataSoal?.tipe?.toLowerCase() || "";
    },

    isObjectiveType() {
      return ["pilihan ganda", "benar salah"].includes(this.tipeNormalized);
    },

    isMatchingType() {
      return this.tipeNormalized === "menjodohkan";
    },

    isEssayType() {
      return ["text", "essay", "essai"].includes(this.tipeNormalized);
    },

    canSubmitReview() {
      return ["PENDING", "REPAIRED"].includes(this.statusReviewKompetensi);
    },

    columns() {
      return [
        { width: "50px", label: "No", name: "-" },
        { width: "100px", label: "Nomor Soal", name: "-" },
        { width: "auto", label: "Tipe", name: "-" },
        { width: "auto", label: "Studi Kasus", name: "-" },
        { width: "auto", label: "Soal Gambar", name: "pertanyaan" },
        { width: "auto", label: "Pertanyaan", name: "-" },
        { width: "auto", label: "Jumlah Jawaban", name: "-" },
        { width: "auto", label: "Status Review", name: "-" },
        { width: "auto", label: "Catatan", name: "-" },
        { width: "150px", label: "Aksi", name: "-" },
      ];
    },
    sortOrders() {
      let sortOrders = [];

      this.columns.forEach((column) => {
        sortOrders[column.name] = -1;
      });
      return sortOrders;
    },
  },
  data() {
    return {
      title: "Review Soal",
      link: process.env.VUE_APP_BACKEND_URL,
      isLoading: true,
      table_data: [],
      sortKey: "kompetensi_idkompetensi",
      currentTablePage: "",
      tableFilter: {
        status: 1,
        search: "",
        page: 1,
        per_page: 10,
        type_soal: "pg",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      idKompetensi: this.$route.params.id,
      kompetensi: {},
      statusReviewKompetensi: "PENDING",
      reviewSteps: REVIEW_STEPS,
      statusReviewBySoal: {},
      showModalImagePreview: false,
      showModalSoalPreview: false,
      previewUrl: "",
      previewDataSoal: null,
      searchDebounced: () => {},
    };
  },
  mounted() {
    this.getKompetensi();
    this.getReviewKompetensiStatus();
    this.getData();
    this.searchDebounced = _.debounce(() => this.getData(), 500);
  },
  methods: {
    async getKompetensi() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          Accept: `Application/json`,
        },
      }).then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    async getReviewKompetensiStatus() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/review-soal/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          Accept: "Application/json",
        },
      }).then((response) => response.data.data);

      if (data?.status_review) {
        this.statusReviewKompetensi = data.status_review;
      }

      const reviewSoalList = data?.reviewSoal ?? data?.review_soal ?? [];
      this.statusReviewBySoal = reviewSoalList.reduce((acc, item) => {
        acc[item.idverif_soal] = item.status_review;
        return acc;
      }, {});
    },
    statusReviewSoal(idverif_soal) {
      return this.statusReviewBySoal[idverif_soal] || "PENDING";
    },
    async submitReview() {
      const result = await Swal.fire({
        icon: "question",
        title: "Kirim Hasil Review?",
        text: "Semua soal yang sudah direview akan dikirim. Pastikan seluruh soal telah direview.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya, Kirim",
        denyButtonText: "Batal",
      });

      if (!result.isConfirmed) return;

      Swal.fire({
        title: "Memproses...",
        text: "Sedang mengirim hasil review",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await axios({
          method: "post",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            `verifikasi/review-soal/${this.idKompetensi}/submit`,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Hasil review berhasil dikirim.",
          timer: 1500,
          showConfirmButton: false,
        });

        this.getReviewKompetensiStatus();
        this.getData();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text:
            error.response?.data?.meta?.message ||
            error.response?.data?.data?.[0] ||
            "Terjadi kesalahan saat mengirim hasil review.",
        });
      }
    },
    async getData(resetPage = true) {
      if (resetPage) {
        this.tableFilter.page = 1;
      }
      this.isLoading = true;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi +
          "/soal",
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    previewImage(url) {
      this.previewUrl = url;
      this.showModalImagePreview = true;
    },
    async previewSoal(id) {
      try {
        Swal.showLoading();
        const res = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "verifikasi/kompetensi-level/" +
            this.idKompetensi +
            "/soal/" +
            id,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });
        Swal.close();

        this.previewDataSoal = res.data.data;
        this.showModalSoalPreview = true;
      } catch (err) {
        console.error(err);
      }
    },

    getImageUrl(path) {
      return this.link + path;
    },

    reviewSoal(idverif_soal) {
      this.$router.push({
        name: "review-soal-form",
        params: {
          id: this.idKompetensi,
          idSoal: idverif_soal,
        },
      });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },

    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getData(false);
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Soal</div>
                  <div>
                    <span class="font-weight-bold">Kode Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.kode_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.nama_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                  <router-link
                    class="btn btn-secondary btn-sm"
                    :to="{ name: 'review-soal-kompetensi-level' }"
                  >
                    <i class="fa fa-arrow-left me-1"></i> Kembali
                  </router-link>
                  <button
                    class="btn btn-warning btn-sm"
                    v-if="canSubmitReview"
                    :disabled="table_data.length == 0"
                    @click="submitReview"
                  >
                    <i class="fa fa-paper-plane me-1"></i>
                    Kirim Hasil Review
                  </button>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <StepProgress
                  :currentStatus="statusReviewKompetensi"
                  :steps="reviewSteps"
                />
              </div>
              <div class="col-12">
                <hr />
              </div>
            </div>

            <div class="d-flex justify-content-between mb-2">
              <div class="d-flex align-items-end">
                <table>
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <div style="max-width: 50%; width: 500px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="searchTable"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="searchDebounced()"
                />
              </div>
            </div>
            <div class="row">
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="isLoading">
                    <td class="text-center" colspan="99">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in table_data"
                    :key="key_data"
                  >
                    <td>{{ key_data + pagination.from }}</td>
                    <td>{{ row_data.nomor_urut ?? "-" }}</td>
                    <td>{{ row_data.tipe }}</td>
                    <td>{{ row_data.objektif?.kategori?.kategori ?? "-" }}</td>
                    <td>
                      <div
                        class="container-image"
                        v-if="row_data.pertanyaan_gambar"
                      >
                        <img
                          v-if="row_data.pertanyaan_gambar"
                          :src="link + row_data.pertanyaan_gambar"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="
                              previewImage(link + row_data.pertanyaan_gambar)
                            "
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>{{ row_data.pertanyaan }}</td>
                    <td class="text-center">{{ row_data.jawaban_count }}</td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="{
                          'bg-warning':
                            statusReviewSoal(row_data.idverif_soal) ===
                            'PENDING',
                          'bg-danger':
                            statusReviewSoal(row_data.idverif_soal) ===
                            'REVISION',
                          'bg-info':
                            statusReviewSoal(row_data.idverif_soal) ===
                            'REPAIRED',
                          'bg-success':
                            statusReviewSoal(row_data.idverif_soal) ===
                            'COMPLETED',
                        }"
                      >
                        {{ statusReviewSoal(row_data.idverif_soal) }}
                      </span>
                    </td>
                    <td>{{ row_data.catatan_validator || "-" }}</td>
                    <td>
                      <div class="d-flex gap-1 justify-content-center">
                        <button
                          class="btn btn-info btn-sm"
                          @click="previewSoal(row_data.idverif_soal)"
                          v-if="row_data.active_flag"
                        >
                          <i class="fa fa-search me-1"></i> Preview
                        </button>
                        <button
                          class="btn btn-primary btn-sm"
                          @click="reviewSoal(row_data.idverif_soal)"
                          v-if="row_data.active_flag"
                        >
                          <i class="fa fa-clipboard-check me-1"></i> Review
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
            </div>

            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <ModalImagePreview v-model="showModalImagePreview" :url="previewUrl" />

  <ModalSoalPreview
    v-model="showModalSoalPreview"
    :data="previewDataSoal"
    :link="link"
  />
</template>

<style scoped>
.popover-catatan {
  max-width: 280px;
  border-radius: 10px;
  border: none;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* optional: kalau gambar gede banget (diagram) */
@media (min-width: 1200px) {
  .soal-image {
    max-height: 500px;
  }
}
</style>
